import React from 'react'
import { cn } from '@utils/safeTs'
import { ChevronUp, ChevronDown } from '@components/icons'
import styles from './MyAccountTable.module.sass'

type SortDirection = 'asc' | 'desc'

export type MyAccountTableHeadersType = { key: string, label?: string | React.ReactNode, align?: 'left' | 'center' | 'right' }[] 
export type MyAccountTableSortType = { key: string, direction: SortDirection }[]

interface Props {
  headers?: MyAccountTableHeadersType
  sort?: {
    keys: string[]
    max?: number
    onSort: (s: MyAccountTableSortType) => void
    activeSort: MyAccountTableSortType
  },
  children?: React.ReactNode
  className?: string
}

const MyAccountTable = (props: Props) => {

  const { 
    headers,
    sort,
    children,
    className = '',
  } = props

  const getHeaderContent = (h) => (
    <>
      {h.label}
      {sort?.keys?.includes(h.key) && (
        sort.activeSort?.filter(s => s.key === h.key)?.[0]?.direction === 'asc' ? <ChevronUp /> : <ChevronDown />
      )}
    </>
  )

  const onSort = (k) => {
    const kPrev = sort?.activeSort?.filter(p => p.key === k)?.[0]
    return sort.onSort([
      { key: k, direction: kPrev?.direction === 'asc' ? 'desc' : 'asc' as SortDirection},
      ...sort?.activeSort.filter(p => p.key !== k)
    ].slice(0, sort?.max || 1))
  }

  return (
    <div className={cn(styles.root, className)}>
      <table className={styles.table}>
        {!!headers?.length && (
          <thead>
            <tr>
              {headers.map(h => (
                <th key={h.key} className={h.align ? 'u-align-' + h.align : undefined}>
                  {sort?.keys?.includes(h.key) && !!sort.onSort ? (
                    <button type="button" onClick={() => onSort(h.key)} className={cn(styles.headerSortButton, sort.activeSort?.filter(s => h.key === s.key)?.length ? styles['headerSortButton--active'] : '')}>
                      {getHeaderContent(h)}
                    </button>
                  ) : (
                    getHeaderContent(h)
                  )}
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {children}
        </tbody>
      </table>
    </div>
  )
}

export default MyAccountTable
